import { Dialog, DialogContent, DialogProps } from "@mui/material";
import { Box } from "@mui/system";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import SpotCreateUpdate, { SpotCreateUpdateProps } from "./SpotCreateUpdate";

export interface OwnProps {
  createUpdateProps: SpotCreateUpdateProps;
}

type Props = OwnProps & DialogProps;

export default function SpotCreateUpdateModal({ createUpdateProps, ...dialogProps }: Props) {
  const isCreate = !createUpdateProps.spotId;

  return (
    <Dialog fullWidth maxWidth='md' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        {isCreate ? "Create new" : "Edit"} spot
      </AppModalTitle>
      <DialogContent>
        <Box sx={{ py: 1 }}>
          <SpotCreateUpdate {...createUpdateProps} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
